import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMailOpen",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, p, _, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--mail-open"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Mail Open",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.5 1.5a.5.5 0 0 0-.3.1l-4 3a.5.5 0 0 0-.14.163l4.192 2.664a.47.47 0 0 0 .496 0h.002l4.19-2.663a.516.516 0 0 0-.141-.165h-.002L6.8 1.6a.5.5 0 0 0-.3-.1ZM11 5.91 7.28 8.274a1.47 1.47 0 0 1-1.56 0l-.003-.002L2 5.91V10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V5.91ZM5.6.8a1.5 1.5 0 0 1 1.8 0l4.002 3.002c.372.282.598.723.598 1.198v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 1 10V5a1.5 1.5 0 0 1 .6-1.2l4-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=mail-open.js.map
